export { BottomBar } from "./BottomBar";
export { BottomBarItem } from "./BottomBarItem";

export type {
  BottomBarItemData,
  BottomBarItemProps,
  BottomBarItemState,
  BottomBarLinkProps,
  BottomBarProps,
} from "./types";
